import FeedList from "./FeedList"
import useFetchApps from "utils/useFetchApps"
import { fetchGames } from "queries"
import usePullToRefresh from "utils/usePullToRefresh"
import useFiltersStore from "stores/filters"

export const Games = () => {
  const price = useFiltersStore((state) => state.price)
  const {
    data: games,
    isFetchingNextPage,
    fetchNextPage,
    refetch,
  } = useFetchApps({
    queryFn: ({ pageParam }) => fetchGames({ price, pageParam }),
    queryKey: price ? ["getGames", price] : ["getGames"],
  })
  usePullToRefresh({ refetch, element: "#games-card", page: "games" })

  return (
    <div id="games-card">
      <FeedList
        apps={games}
        isPending={isFetchingNextPage}
        endReached={fetchNextPage}
      />
    </div>
  )
}
export default Games
